import React from 'react';
import { Grid, Card } from '@mui/material';
import BuscarOrdenesForm from './BuscarOrdenesForm';

const ValidarOrden = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Card sx={{ width: '100%', p: 0 }}>
          <BuscarOrdenesForm 
            modo='validar'
            titulo='Validar ordenes a través de QR'
            descripcion='Registrá la orden escaneando el QR desde Mi OSER. Al validarse, se digitaliza y se firma electrónicamente.'
          />
        </Card>
      </Grid>
    </Grid>
  );
};

export default ValidarOrden;
